import api from '@services/api';
import { ProjectSubTypeResponse } from '../models/projectSubTypes';

/**
 * <p>
 * API endpoints that cover all project sub type related CRUD calls
 */
export const projectsSubTypeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    projectSubType: builder.query<ProjectSubTypeResponse[], void>({
      query: () => ({
        url: encodeURI(`/report/project-subtype/list`),
      }),
      providesTags: ['ProjectSubType'],
    }),
  }),
});

export const { useProjectSubTypeQuery } = projectsSubTypeApi;
